import 'zone.js/dist/zone';
import 'zone.js/dist/zone-patch-rxjs';
import 'zone.js/dist/zone-patch-rxjs-fake-async'; // add this
import 'core-js/es6/reflect';
import 'core-js/es7/reflect';
import '@angular/localize/init';
